// extracted by mini-css-extract-plugin
module.exports = {"h2_subtitle":"Skills_h2_subtitle__1MGHh","item_skill":"Skills_item_skill__y3bN3"};